<template>
<div class="profile-img flex-center-children">
    <FaIcon v-if="showFallbackImg" icon="user-circle"/>
    <img v-else :src="profileImgUrl" @error="hasImgErr = true" alt="profile"/>
</div>
</template>

<script>
export default {
    name: 'UserProfileImage',
    props: {
        src: String,
        guanzo: Boolean,
    },
    data: () => ({
        hasImgErr: false,
        guanzoImgUrl: 'https://static-cdn.jtvnw.net/jtv_user_pictures/bd1d2400-3c33-48b8-8e13-50d866b6ad89-profile_image-300x300.png',
    }),
    computed: {
        profileImgUrl: vm => vm.guanzo ? vm.guanzoImgUrl : vm.src,
        showFallbackImg: vm => !vm.profileImgUrl || vm.hasImgErr,
    },
}
</script>

<style lang="scss" scoped>
$img-size: 20px;

.profile-img {
    width: $img-size;
    min-width: $img-size;
    height: $img-size;
    img {
        border-radius: 50%;
    }
    .fa-user-circle {
        font-size: $img-size;
    }
}
</style>
